require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/babel-runtime/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 779
// module chunks = 0